var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5088 11.1429C14.5924 11.1429 17.1011 8.63415 17.1011 5.55052C16.8398 -1.85017 6.17746 -1.85017 5.91644 5.55052C5.91644 8.63415 8.42515 11.1429 11.5088 11.1429ZM11.5088 2.04878C16.1291 2.19507 16.1291 8.90592 11.5088 9.05227C6.88844 8.90597 6.88844 2.19512 11.5088 2.04878ZM23.007 22.9547C23.007 23.5296 22.5366 24 21.9617 24H5.33077C3.95086 23.979 3.96137 21.9304 5.33077 21.9094H20.843C20.3308 17.9685 16.9441 14.9059 12.8677 14.9059H10.1394C5.70738 14.9059 2.09059 18.5122 2.09059 22.9547C2.06959 24.3346 0.0210254 24.3241 0 22.9547C0 17.3624 4.54704 12.8153 10.1394 12.8153H12.8677C18.46 12.8153 23.007 17.3624 23.007 22.9547Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f8bc84acdb53688d448c2d00af5ca6aa.svg";
export { ForwardRef as ReactComponent };